import { createSelector } from 'reselect'
import { extractDoi } from 'lib/helpers/search'

export const selectMaybeDoi = createSelector(
  state => state.search.term,
  term => extractDoi(term)
)

export const selectLinkResolver = createSelector(
  state => state.linkResolver,
  state => state.hasUser,
  state => state.fetchingUser,
  state => state.user,
  (linkResolver, hasUser, fetchingUser, user) => {
    if (linkResolver) {
      return linkResolver
    }
    return null
  }
)
